// extracted by mini-css-extract-plugin
export var dropdown = "_fc-0";
export var imagePlaceholder = "_fc-2";
export var imageWrapper = "_fc-3";
export var productImage = "_fc-1";
export var truncateContainer = "_fc-4";
export var truncateText = "_fc-5";